<template>
  <div class="project-register-detail">
    <Spin v-if="loading"></Spin>
    <detail-zheng-zhou-ren-she :projectModel="projectModel" v-else-if="mode==='ZhengZhouRenShe'" />
    <detail-jiao-zuo-ren-she :projectModel="projectModel" v-else-if="mode==='JiaoZuoRenShe'" />
    <detail-hai-nan-ren-she :projectModel="projectModel" v-else-if="mode==='HaiNanRenShe'" />
    <Alert type="error" show-icon v-else>
      啊偶！出错了
      <span slot="desc">
        您没有访问当前页面的权限
      </span>
    </Alert>
  </div>
</template>

<script>
import DetailZhengZhouRenShe from './ZhengZhouRenShe/Detail.vue'
import DetailJiaoZuoRenShe from './JiaoZuoRenShe/Detail.vue'
import DetailHaiNanRenShe from './HaiNanRenShe/Detail.vue'
export default {
  name: 'project-register-detail',
  props: {
  },
  components: {
    DetailZhengZhouRenShe,
    DetailJiaoZuoRenShe,
    DetailHaiNanRenShe
  },
  data () {
    return {
      loading: false,
      supvPerms: {
        canAuditGuarantor: false,
        canPreAuditGuarantor: false,
        canBlacklistGuarantor: false,
        canClaim: false,
        canAddProjectRegister: false,
        canAuditProjectRegister: false,
        projectRegisterMode: null
      },
      mode: '',
      projectModel: {
        industryId: null,
        cityId: null,
        method: 0, // 存储方式：0-保函|1-现金
        projectName: null,
        projectSite: null,
        projectStruc: null,
        projectScale: null,
        projectCost: 0,
        projectStartDate: null,
        projectEndDate: null,
        daterange: null,
        duration: null,
        ownerName: null,
        ownerManager: null,
        ownerManagerTel: null,
        contractorName: null,
        contractorManager: null,
        contractorManagerTel: null,
        payableBase: 0,
        payableAmount: 0,
        payableRatio: 2,
        opName: null,
        opTel: null,
        status: null,
        supervisorName: null,
        guarantorName: null,
        guarantorAddress: null,
        guarantorContact: null,
        guarantorTel: null,
      },
    }
  },
  watch: {
  },
  async mounted () {
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode
    }
    // await this.getMySupervisionPermission()
    await this.getDetail().then(async () => {
      await this.getProjectRegisterMode()
    })
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    async getProjectRegisterMode () {
      this.loading = true
      await this.$Api.ProjectRegister.getProjectRegisterMode(this.projectModel.supervisorName, this.projectModel.cityId, this.projectModel.industryId)
      .then((res) => {
        // console.log(res)
        this.mode = res
        this.loading = false
        return Promise.resolve()
      })
      .catch((err) => {
        this.loading = false
        this.mode = ''
        return Promise.reject(err)
      })
    },
    async getDetail () {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$Spin.show()
        this.$Api.ProjectRegister.getProjectRegisterDetail(this.$route.params.orderNumber)
          .then((payload) => {
            payload.payableRatio = Math.round(payload.payableRatio * 100 * 100) / 100
            payload.payableAmount = Math.round(payload.payableAmount / 100)
            payload.payableBase /= 100
            payload.projectCost /= 100
            this.projectModel = payload
            this.loading = false
            this.$Spin.hide()
            resolve(this.projectModel)
          })
          .catch(err => {
            console.log('err', err)
            this.$Message.error('载入失败!' + err.message)
            this.loading = false
            this.$Spin.hide()
            reject(err)
          })
      })
    },
  }
}
</script>

<style lang="less" scoped>
</style>
